import React, { useState } from 'react';
import { Paper } from '@mui/material';
import ActivityProgressPopup from './Popup';
import ActivityProgressSummary from './Summary';

const ActivityProgressSection = function ActivityProgressSection({
  customerId,
  campaignId,
  activeCampaigns = [],
  sidebarOpen = false,
}) {
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  return (
    <>
      <ActivityProgressPopup
        open={open}
        onClose={handleToggle}
        customerId={customerId}
        campaignId={campaignId}
        activeCampaigns={activeCampaigns}
        sidebarOpen={sidebarOpen}
      />
      <Paper sx={{ height: '100%', flexGrow: 1 }}>
        <ActivityProgressSummary
          open={open}
          onToggle={handleToggle}
          status={
            activeCampaigns.find((campaign) => campaign.id === campaignId)
              ?.dividerName
          }
        />
      </Paper>
    </>
  );
};

export default ActivityProgressSection;
